module.exports = __webpack_public_path__ + "img/Shield_pending.f67adc57.svg";